import React from 'react'

export default function FullPageGridContainer({ children, ...props }) {

  return (
    <div className="w-full" style={{ height: "calc(100vh - 128px" }}>
      {children}
    </div>
  )
}